import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShare2, FiUserPlus } = FiIcons;

export default function Navbar({ onLogoClick, onSignUp }) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between">
        <button 
          onClick={onLogoClick}
          className="flex items-center gap-2 group"
        >
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg group-hover:rotate-12 transition-transform">
            <SafeIcon icon={FiShare2} className="w-6 h-6 text-white" />
          </div>
          <span className="text-xl font-black text-gray-900 tracking-tight">ClipShares</span>
        </button>

        <div className="flex items-center gap-4">
          <button 
            onClick={onSignUp}
            className="flex items-center gap-2 px-6 py-2.5 bg-gray-900 text-white rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all shadow-lg shadow-gray-200"
          >
            <SafeIcon icon={FiUserPlus} className="w-4 h-4" />
            Sign Up
          </button>
          
          <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-green-50 rounded-full border border-green-100">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <span className="text-[10px] font-black text-green-700 uppercase tracking-widest">Network Live</span>
          </div>
        </div>
      </div>
    </nav>
  );
}